<style lang="scss" scoped>
/deep/ .comp-vehicle-insurance-export-dialog {
    margin-top: 6vh !important;
    max-width: 980px;
    width: 92%;

    .el-dialog__body {
        padding: 18px 22px 22px;
    }
}

.vehicle-insurance-export {
    .filter-panel {
        padding: 16px 16px 8px;
        border: 1px solid #ebeef5;
        border-radius: 4px;
        background: #fafafa;
    }

    .filter-item {
        width: 100%;
        margin-bottom: 8px;
    }

    .export-alert {
        margin: 14px 0;
    }

    .export-actions {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        grid-gap: 12px;
    }

    .export-card {
        padding: 14px;
        border: 1px solid #ebeef5;
        border-radius: 4px;
        background: #fff;
    }

    .export-title {
        margin-bottom: 6px;
        color: #303133;
        font-size: 14px;
        font-weight: bold;
    }

    .export-desc {
        min-height: 36px;
        margin-bottom: 12px;
        color: #909399;
        font-size: 12px;
        line-height: 18px;
    }

    .export-button {
        width: 100%;
    }
}
</style>

<template>
    <el-dialog title="车辆保险数据导出" custom-class="c-el-dialog comp-vehicle-insurance-export-dialog"
        :visible.sync="showDialog" :before-close="_close">
        <div class="vehicle-insurance-export">
            <div class="filter-panel">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12" :md="8">
                        <el-checkbox class="filter-item" v-model="form.isFilterArea" label="仅看当前服务区" border size="medium"
                            @change="changeIsFilterArea"></el-checkbox>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="8" v-show="!form.isFilterArea">
                        <el-select class="filter-item" placeholder="平台筛选" size="medium" filterable clearable
                            v-model="form.platform" @change="changePlatform">
                            <el-option v-for="item in allPlatforms" :key="'export-platform-' + item" :label="item" :value="item"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="8" v-show="!form.isFilterArea && form.platform">
                        <el-select class="filter-item" placeholder="服务区筛选" size="medium" filterable clearable
                            v-model="form.area">
                            <el-option v-for="item in dialogServiceAreas" :key="'export-area-' + item.id" :label="item.name" :value="item.name"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="8">
                        <el-select class="filter-item" placeholder="保险状态筛选" size="medium" multiple collapse-tags
                            clearable v-model="form.insuranceStatuses">
                            <el-option label="正常" :value="0"></el-option>
                            <el-option label="无保险" :value="1"></el-option>
                            <el-option label="已过期" :value="2"></el-option>
                            <el-option label="即将到期" :value="3"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="8">
                        <el-select class="filter-item" placeholder="近期订单筛选" size="medium" filterable clearable
                            v-model="form.hasRecentOrder">
                            <el-option label="近N天有订单" :value="true"></el-option>
                            <el-option label="近N天无订单" :value="false"></el-option>
                        </el-select>
                    </el-col>
                    <!-- <el-col :xs="24" :sm="12" :md="8">
                        <el-select class="filter-item" placeholder="保单查询" size="medium" filterable clearable
                            v-model="form.hasInsurance">
                            <el-option label="有保单" :value="true"></el-option>
                            <el-option label="无保单" :value="false"></el-option>
                        </el-select>
                    </el-col> -->
                    <el-col :xs="24" :sm="12" :md="8">
                        <el-select class="filter-item" placeholder="车架号查询" size="medium" filterable clearable
                            v-model="form.hasChassisNo">
                            <el-option label="有车架号" :value="true"></el-option>
                            <el-option label="无车架号" :value="false"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="8">
                        <el-input class="filter-item" placeholder="输入搜索内容" clearable v-model="form.keywords"
                            size="medium"></el-input>
                    </el-col>
                </el-row>
            </div>

            <el-alert class="export-alert" type="warning" :closable="false"
                title="以下所有导出都基于当前筛选条件查询的数据导出!"></el-alert>

            <div class="export-actions">
                <div class="export-card" v-for="item in exportOptions" :key="item.type">
                    <div class="export-title">{{ item.title }}</div>
                    <div class="export-desc">{{ item.desc }}</div>
                    <el-button class="export-button" size="medium" :loading="exportingType === item.type"
                        :type="item.btnType"
                        :plain="item.plain"
                        :disabled="isExporting" @click="handleExport(item)">
                        {{ item.title }}
                    </el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { VehicleInsurances } from "@/mixins/commonPageExport"
import * as funReport from "@/api/report"
import * as funAll from "@/api/all"
import moment from "moment"

const AREA_CHECK_RESULTS = ["匹配失败", "一致", "不一致"]

export default {
    name: "VehicleInsuranceExportDialog",
    props: {
        query: {
            type: Object,
            default: () => ({})
        },
        allPlatforms: {
            type: Array,
            default: () => []
        },
        allServiceAreas: {
            type: Array,
            default: () => []
        },
        serviceAreaCityData: {
            type: Array,
            default: () => []
        },
        maxExportCounts: {
            type: Number,
            default: 20000
        }
    },
    data() {
        return {
            showDialog: false,
            form: {},
            dialogServiceAreas: [],
            exportingType: "",
            exportOptions: [
                {
                    type: "all",
                    title: "按筛选条件全量导出",
                    desc: "不做去重，直接导出当前筛选条件命中的车辆保险数据。",
                    btnType: "primary",
                    plain: false
                },
                {
                    type: "chassisControl",
                    title: "按车架中控去重导出",
                    desc: "按车架号、中控号、最后在线时间、最后订单时间、最后同步时间依次兜底去重。",
                    btnType: "warning",
                    plain: false
                },
                {
                    type: "chassisNo",
                    title: "仅车架号去重导出",
                    desc: "只按车架号去重，车架号为空的数据原样保留。",
                    btnType: "info",
                    plain: true
                },
                {
                    type: "controlNo",
                    title: "仅中控号去重导出",
                    desc: "只按中控号去重，中控号为空的数据原样保留。",
                    btnType: "info",
                    plain: true
                },
                {
                    type: "vehicleNo",
                    title: "仅车辆号去重导出",
                    desc: "只按车辆号去重，车辆号为空的数据原样保留。",
                    btnType: "info",
                    plain: true
                },
                {
                    type: "insurancePolicyNumber",
                    title: "仅保单号去重导出",
                    desc: "只按保险单号去重，保险单号为空的数据原样保留。",
                    btnType: "info",
                    plain: true
                }
            ]
        }
    },
    computed: {
        isExporting() {
            return !!this.exportingType
        }
    },
    methods: {
        open() {
            this.form = this.clone(this.query)
            this.dialogServiceAreas = this.clone(this.allServiceAreas)
            if (this.form.platform && !this.form.isFilterArea && this.dialogServiceAreas.length === 0) {
                this.queryAllServiceAreas(this.form.platform)
            }
            this.showDialog = true
        },
        _close() {
            if (this.isExporting) return false
            this.showDialog = false
        },
        clone(data) {
            return JSON.parse(JSON.stringify(data || {}))
        },
        normalizeValue(value) {
            if (value === null || value === undefined) return ""
            return String(value).trim()
        },
        getTimeValue(value) {
            const time = moment(value)
            return time.isValid() ? time.valueOf() : 0
        },
        changeIsFilterArea() {
            this.form.platform = ""
            this.form.area = ""
        },
        changePlatform(val) {
            this.form.platform = val || ""
            this.form.area = ""
            this.dialogServiceAreas = []
            if (val) {
                this.form.isFilterArea = false
                this.queryAllServiceAreas(val)
            }
        },
        async queryAllServiceAreas(platform) {
            const res = await funAll.AllServiceAreas({ platform: platform || "", isActive: true })
            this.dialogServiceAreas = res || []
            this.dialogServiceAreas.sort((a, b) => {
                if (a.enableSpider && !b.enableSpider) return -1
                if (!a.enableSpider && b.enableSpider) return 1
                return 0
            })
        },
        buildSearchParams() {
            const searchs = this.clone(this.form)
            searchs.page = 1
            searchs.size = this.maxExportCounts
            if (!searchs.insuranceStatuses || searchs.insuranceStatuses.length === 0) {
                delete searchs.insuranceStatuses
            }
            if (searchs.hasRecentOrder === null || searchs.hasRecentOrder === undefined || searchs.hasRecentOrder === "") {
                delete searchs.hasRecentOrder
            }
            if (searchs.isFilterArea) {
                searchs.platform = this.$store.getters.servicePlatform || ""
                searchs.area = this.$store.getters.serviceArea || ""
            }
            return searchs
        },
        async handleExport(option) {
            this.exportingType = option.type
            window.$common.fullLoading()
            try {
                const searchs = this.buildSearchParams()
                const res = await funReport.GetVehicles(searchs)
                if (!res || !res.items || res.items.length <= 0) {
                    window.$common.closeFullLoading()
                    this.alert("没有需要导出的数据!")
                    return
                }
                if (res.totalCount > this.maxExportCounts) {
                    window.$common.closeFullLoading()
                    this.warningMsg(`当前筛选条件命中${res.totalCount}条数据，不允许导出超过${this.maxExportCounts}条数据，请缩小筛选条件!`)
                    return
                }

                let tableDatas = res.items.map((x, index) => this.formatExportItem(x, index))
                tableDatas = this.applyExportMode(tableDatas, option.type)
                const exportName = this.getExportName(searchs, option.title)
                VehicleInsurances(exportName, tableDatas)
            } catch (error) {
                window.$common.closeFullLoading()
                console.log("export error", error)
                this.alert("导出失败，请重试!")
            } finally {
                this.exportingType = ""
            }
        },
        formatExportItem(row, index) {
            const item = { ...row, __exportIndex: index }
            item.platformDesc = item.platform || this.$store.getters.servicePlatform || ""
            item.areaFullName = `${item.platformDesc}-${item.area}` // || ""
            item.insuranceStartDate = moment(item.insuranceStartDate).isValid() ? moment(item.insuranceStartDate).format("YYYY-MM-DD") : ""
            item.insuranceEndDate = moment(item.insuranceEndDate).isValid() ? moment(item.insuranceEndDate).format("YYYY-MM-DD") : ""
            item.lastSyncTimeDesc = moment(item.lastSyncTime).isValid() ? moment(item.lastSyncTime).format("YYYY-MM-DD HH:mm:ss") : ""
            item.lastOrderTimeDesc = moment(item.lastOrderTime).isValid() ? moment(item.lastOrderTime).format("YYYY-MM-DD HH:mm:ss") : ""
            item.lastOnlineTimeDesc = moment(item.lastOnlineTime).isValid() ? moment(item.lastOnlineTime).format("YYYY-MM-DD HH:mm:ss") : ""
            item.areaCheckResult = this.checkAreaMatch(item.platform, item.area, item.insuranceArea)
            item.isDetainedDesc = item.isDetained ? "是" : ""

            // 保险状态直接使用后端计算的字段
            item.insuranceStatusDesc = item.insuranceStatusDesc || ""
            item.isDetained = !!item.isDetained
            item.detainedPointName = item.detainedPointName || (item.isDetained ? "被扣" : "")
            return item
        },
        checkAreaMatch(platform, area, insuranceArea) {
            if (!insuranceArea) return AREA_CHECK_RESULTS[0]
            if (insuranceArea.includes("中华人民共和国")) return AREA_CHECK_RESULTS[1]
            if (!this.serviceAreaCityData || this.serviceAreaCityData.length === 0) return AREA_CHECK_RESULTS[0]

            const matchedConfig = this.serviceAreaCityData.find(item => item.platform === platform && item.name === area)
            if (!matchedConfig || !matchedConfig.city) return AREA_CHECK_RESULTS[0]
            if (matchedConfig.city.includes(insuranceArea)) return AREA_CHECK_RESULTS[1]
            return AREA_CHECK_RESULTS[2]
        },
        applyExportMode(data, type) {
            if (type === "all") return data
            if (type === "chassisControl") return this.deduplicateByChassisControl(data)
            return this.deduplicateByField(data, type)
        },
        isBetterByTime(candidate, current) {
            const candidateLastOnlineTime = this.getTimeValue(candidate.lastOnlineTime)
            const currentLastOnlineTime = this.getTimeValue(current.lastOnlineTime)
            if (candidateLastOnlineTime !== currentLastOnlineTime) {
                return candidateLastOnlineTime > currentLastOnlineTime
            }

            // 判断双方是否拥有 lastOrderTime
            const candidateHasOrderTime = this.getTimeValue(candidate.lastOrderTime) > 0
            const currentHasOrderTime = this.getTimeValue(current.lastOrderTime) > 0
            // 两个都有，以最新时间为准
            if (candidateHasOrderTime && currentHasOrderTime) {
                const candidateLastOrderTime = this.getTimeValue(candidate.lastOrderTime)
                const currentLastOrderTime = this.getTimeValue(current.lastOrderTime)
                if (candidateLastOrderTime !== currentLastOrderTime) {
                    return candidateLastOrderTime > currentLastOrderTime
                }
            } else if (candidateHasOrderTime !== currentHasOrderTime) {
                // 只有一个有 lastOrderTime：若两者 lastSyncTime 为同一天则以有 lastOrderTime 的为准，
                // 否则按 lastSyncTime 最新为准（交由下方 lastSyncTime 比较处理）
                const candidateSync = moment(candidate.lastSyncTime)
                const currentSync = moment(current.lastSyncTime)
                if (candidateSync.isValid() && currentSync.isValid() && candidateSync.isSame(currentSync, "day")) {
                    return candidateHasOrderTime
                }
            }

            const candidateLastSyncTime = this.getTimeValue(candidate.lastSyncTime)
            const currentLastSyncTime = this.getTimeValue(current.lastSyncTime)
            if (candidateLastSyncTime !== currentLastSyncTime) {
                return candidateLastSyncTime > currentLastSyncTime
            }

            return candidate.__exportIndex > current.__exportIndex
        },
        isBetterByCompositeRule(candidate, current) {
            const candidateControlNo = this.normalizeValue(candidate.controlNo)
            const currentControlNo = this.normalizeValue(current.controlNo)
            if (!!candidateControlNo !== !!currentControlNo) {
                return !!candidateControlNo
            }
            return this.isBetterByTime(candidate, current)
        },
        pickBetterItem(group, isComposite) {
            return group.reduce((best, item) => {
                if (!best) return item
                const isBetter = isComposite
                    ? this.isBetterByCompositeRule(item, best)
                    : this.isBetterByTime(item, best)
                return isBetter ? item : best
            }, null)
        },
        deduplicateByField(data, field) {
            const grouped = {}
            const retained = []
            data.forEach(item => {
                const key = this.normalizeValue(item[field])
                if (!key) {
                    retained.push(item)
                    return
                }
                if (!grouped[key]) grouped[key] = []
                grouped[key].push(item)
            })

            Object.values(grouped).forEach(group => {
                retained.push(this.pickBetterItem(group, false))
            })
            return retained.sort((a, b) => a.__exportIndex - b.__exportIndex)
        },
        getCompositeKey(item) {
            const chassisNo = this.normalizeValue(item.chassisNo)
            if (chassisNo) return `chassisNo:${chassisNo}`

            const controlNo = this.normalizeValue(item.controlNo)
            if (controlNo) return `controlNo:${controlNo}`

            const lastOnlineTime = this.getTimeValue(item.lastOnlineTime)
            if (lastOnlineTime) return `lastOnlineTime:${lastOnlineTime}`
            
            const lastOrderTime = this.getTimeValue(item.lastOrderTime)
            if (lastOrderTime) return `lastOrderTime:${lastOrderTime}`

            const lastSyncTime = this.getTimeValue(item.lastSyncTime)
            if (lastSyncTime) return `lastSyncTime:${lastSyncTime}`

            return ""
        },
        deduplicateByChassisControl(data) {
            const grouped = {}
            const retained = []
            data.forEach(item => {
                const key = this.getCompositeKey(item)
                if (!key) {
                    retained.push(item)
                    return
                }
                if (!grouped[key]) grouped[key] = []
                grouped[key].push(item)
            })

            Object.values(grouped).forEach(group => {
                retained.push(this.pickBetterItem(group, true))
            })
            return retained.sort((a, b) => a.__exportIndex - b.__exportIndex)
        },
        getExportName(searchs, title) {
            const prefix = `${searchs.platform || ""}${searchs.area || ""}`
            return `${prefix}车辆保险信息表-${title}.xlsx`
        }
    }
}
</script>
